import React, { useState, useEffect, useContext } from 'react';

import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography, Stack, Button, Chip } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { isEmpty } from 'lodash';
import { DataContext } from '../../../context/DataContext';
import { isAccess, simpleMessage } from '../../../helpers/Helpers';
import { deleteToken, deleteUserData, getToken } from '../../../api/Account';
import NoData from '../../../components/NoData';
import { PaginationComponent } from '../../../components/PaginationComponent';

import SmallModal from '../../../components/modals/SmallModal';
import Swal from 'sweetalert2';
import { deleteHolidayAsync, getHolidaysByYearAsync } from '../../../api/Holiday';
import AddHoliday from './AddHoliday';
import moment from 'moment/moment';
import { monoFont } from '../../../theme';

const HolidayList = () => {
	const [holidayList, setHolidayList] = useState([]);
	const [localReload, setLocalReload] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const { access, setIsLoading, setIsLogged, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getHolidaysByYearAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setHolidayList(result.data.result);
		})();
	}, [localReload]);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsperPage] = useState(10);
	const indexLast = currentPage * itemsperPage;
	const indexFirst = indexLast - itemsperPage;
	const currentItem = holidayList.slice(indexFirst, indexLast);
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const deleteHoliday = async (id) => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await deleteHolidayAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'eX01') {
							deleteUserData();
							deleteToken();
							setIsLogged(false);
							return;
						}
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Eliminado!', 'Tasa de Interes Eliminada.', 'success');
				})();
			}
		});
	};

	return (
		<div>
			<Paper sx={{ overflow: 'hidden' }}>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid', borderColor: 'divider' }}>
					<Typography sx={{ fontSize: 15, fontWeight: 600 }}>Feriados</Typography>
					{isAccess(access, 'CONFIG CREATE') ? (
						<Button onClick={() => setShowModal(true)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
							Agregar
						</Button>
					) : null}
				</Box>

				{isEmpty(currentItem) ? (
					<NoData />
				) : (
					<Stack spacing={0}>
						<TableContainer sx={{ overflowX: 'auto' }}>
							<Table size="small" sx={{ minWidth: 640 }}>
								<TableHead>
									<TableRow>
										<TableCell>#</TableCell>
										<TableCell>Fecha</TableCell>
										<TableCell>Descripción</TableCell>
										<TableCell>Sucursales</TableCell>
										{isAccess(access, 'CONFIG DELETE') ? <TableCell align="center">Eliminar</TableCell> : null}
									</TableRow>
								</TableHead>

								<TableBody>
									{currentItem.map((row) => {
										const { description, festivo, id, sucursals } = row;

										return (
											<TableRow key={id}>
												<TableCell sx={{ fontFamily: monoFont, color: 'text.disabled' }}>{id}</TableCell>
												<TableCell sx={{ fontFamily: monoFont, fontSize: 12.5 }}>{moment(festivo).format('L')}</TableCell>
												<TableCell sx={{ fontWeight: 500 }}>{description}</TableCell>
												<TableCell>
													<Stack spacing={0.5} direction="row" flexWrap="wrap" useFlexGap>
														{sucursals.map((i) => (
															<Chip key={i.id} label={i.description} size="small" />
														))}
													</Stack>
												</TableCell>
												{isAccess(access, 'CONFIG DELETE') ? (
													<TableCell align="center">
														<IconButton size="small" sx={{ color: 'error.main' }} onClick={() => deleteHoliday(id)}>
															<DeleteRoundedIcon sx={{ fontSize: 17 }} />
														</IconButton>
													</TableCell>
												) : null}
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
						<Box sx={{ padding: '10px 20px 14px' }}>
							<PaginationComponent data={holidayList} paginate={paginate} itemsperPage={itemsperPage} />
						</Box>
					</Stack>
				)}
			</Paper>

			<SmallModal titulo={'Agregar Feriado'} isVisible={showModal} setVisible={setShowModal}>
				<AddHoliday setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} />
			</SmallModal>
		</div>
	);
};

export default HolidayList;
